<template>
  <div class="course-schedule-manage-contain">
    <section class="course-schedule-search clearfix">
      <div class="search-lf clearfix">
        <div class="search-module">
          <p class="search-module-name">{{ $t("courseSchedule.year") }}</p>
          <div class="search-module-value" ref="courseModuleWidth">
            <el-select v-model="searchData.year" @change="changeYear">
              <el-option
                v-for="item in yearList"
                :key="'year' + item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="search-module">
          <p class="search-module-name">{{ $t("courseSchedule.courseType") }}</p>
          <div class="search-module-value">
            <el-select v-model="searchData.courseTypeKind" clearable @change="getTypeKey">
              <el-option
                v-for="item in courseTypeList"
                :key="'courseType' + item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="search-module">
          <p class="search-module-name search-module-name2" @click="showSite">
            {{ $t("courseSchedule.choseArea") }}
          </p>
          <div class="search-module-value search-module-value2">
            <el-tooltip
              placement="top-start"
              :disabled="searchData.siteIdArr.length < 4"
              :content="searchData.siteNameCode"
            >
              <el-input
                v-model="searchData.siteNameCode"
                :disabled="true"
                :placeholder="$t('user.select')"
              ></el-input>
            </el-tooltip>
          </div>
        </div>
        <div class="search-module">
          <p class="search-module-name">{{ $t("courseSchedule.courseNameCode") }}</p>
          <div class="search-module-value">
            <el-input
              v-model="searchData.courseNameCode"
              @keyup.enter.native="searchList(true, 0)"
              clearable
              :placeholder="$t('contract.inputTips')"
            ></el-input>
          </div>
        </div>
        <div class="search-module">
          <p class="search-module-name">{{ $t("courseSchedule.city") }}</p>
          <el-popover placement="bottom" :width="calWidth" trigger="click">
            <!--重置-->
            <el-button @click="resetChecked" type="text" size="mini">{{
              $t("reset")
            }}</el-button>
            <el-tree
              style="max-height: 400px; overflow-y: auto"
              ref="cityClassTree"
              :data="areaList"
              show-checkbox
              :render-after-expand="false"
              node-key="cityId"
              @check-change="handleCheckChange"
              :props="cityDefaultProps"
              :default-expand-all="false"
            >
            </el-tree>
            <el-input
              slot="reference"
              :placeholder="$t('user.select')"
              clearable
              readonly
              v-model.trim="cityListName"
            ></el-input>
          </el-popover>
        </div>
        <div class="search-module">
          <p class="search-module-name">{{ $t("courseSchedule.teamCatalog") }}</p>
          <div class="search-module-value clearfix">
            <div class="search-value-select">
              <el-select v-model="searchData.team" clearable @change="getTeamTwo($event)">
                <el-option
                  v-for="item in teamList"
                  :key="'team' + item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-value-select select-secondteam">
              <el-select v-model="searchData.secondTeam" clearable>
                <el-option
                  v-for="item in teamListTwo"
                  :key="'team2' + item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="search-lr">
        <el-button
          class="M-search button-margin-b"
          type="primary"
          @click="searchList(true, 0)"
        >
          {{ $t("query") }}
        </el-button>
        <el-button class="M-search el-back M-margin-l" type="info" @click="resetList">
          {{ $t("reset") }}
        </el-button>
      </div>
    </section>
    <section class="course-schedule-add-buttons">
      <el-tooltip placement="top-start" effect="light">
        <div slot="content">{{ $t("courseSchedule.addTips") }}</div>
        <el-button class="popup-manage-add" type="primary" @click="showAddCourse">
          {{ $t("add") }}
          <em class="el-icon-question"></em>
        </el-button>
      </el-tooltip>
      <el-button type="primary" @click="downLoadTarget" :loading="downloadingData">
        {{ $t("export") }}
      </el-button>
      <el-button type="primary" @click="uploadFileShow">
        {{ $t("courseSchedule.importInfo") }}
      </el-button>
    </section>
    <section class="course-schedule-add-content" v-if="addContainShow">
      <div class="course-schedule-add-info">
        <div class="add-infos clearfix">
          <div class="add-infos-module add-infos-module2">
            <el-button type="primary" @click="showCourse">
              {{ $t("res.rela.alternativeCourse") }}
            </el-button>
          </div>
          <div class="add-infos-module">
            <p class="add-infos-module-name">
              {{ $t("courseSchedule.choseCourseCode") }}
            </p>
            <div class="add-infos-module-value">
              <el-input
                v-model="courseData.courseCode"
                :placeholder="$t('cert.selectTips')"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="add-infos-module add-infos-module5">
            <p class="add-infos-module-name">
              {{ $t("courseSchedule.choseCourseRealTime") }}
            </p>
            <div class="add-infos-module-value">
              <el-input
                v-model="courseData.courseDays"
                :placeholder="''"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="add-infos-module add-infos-module5">
            <p class="add-infos-module-name">{{ $t('courseSchedule.choseCourseTime') }}
              <el-tooltip placement="top-start" effect="light">
                <div slot="content">{{ $t("courseSchedule.choseCourseTimeTips") }}</div>
                <em class="el-icon-question icon-question"></em>
              </el-tooltip>
            </p>
            <div class="add-infos-module-value">
              <el-input
                v-model="courseData.courseScheduledDays"
                :placeholder="''"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="add-infos-module add-infos-module6" v-if="weekShow">
            <p class="add-infos-module-name">{{ $t("courseSchedule.weekendClass") }}</p>
            <div class="add-infos-module-value">
              <el-select v-model="courseData.weekendArrangeFlag">
                <el-option
                  v-for="item in weekClassList"
                  :key="'weekendsClass' + item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="add-infos-module">
            <p class="add-infos-module-name add-infos-module-name2" @click="showSite2">
              {{ $t("courseSchedule.choseArea") }}
            </p>
            <div class="add-infos-module-value">
              <el-tooltip
                class="item"
                :content="courseData.siteNameCode"
                :disabled="
                  !courseData.siteNameCode || courseData.siteNameCode.length < 14
                "
                placement="top"
              >
                <el-input
                  v-model="courseData.siteNameCode"
                  :placeholder="$t('cert.selectTips')"
                  disabled
                ></el-input>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="add-infos2">
          <div class="add-infos-module">
            <el-button type="primary" @click="saveNewTarget">
              {{ $t("confirm") }}
            </el-button>
            <el-button type="info" @click="resetAndClose(false)">
              {{ $t("cancel") }}
            </el-button>
          </div>
        </div>
      </div>
    </section>
    <section class="course-schedule-content">
      <el-table
        v-loading="scheduleLoading"
        border
        class="course-schedule-table"
        :height="calHeight"
        ref="scheduleTable"
        :data="scheduleData"
        stripe
        :span-method="arraySpanMethod"
      >
        <el-table-column
          type="index"
          :label="$t('pop.no')"
          header-align="center"
          align="center"
          fixed
          width="55"
        >
        </el-table-column>
        <template v-for="(item, kindex) in columnList">
          <el-table-column
            :prop="item.prop"
            :key="'courseSchedule' + item.prop"
            show-overflow-tooltip
            :width="item.width"
            header-align="center"
            align="center"
            :formatter="item.formatter"
            :fixed="
              item.prop === 'courseTeamCatalogNames' ||
              item.prop === 'courseKindName' ||
              item.prop === 'courseCode' ||
              item.prop === 'courseName'
            "
            :label="item.label"
            :render-header="item.prop === 'setMode' ? renderHeader : renderHeader2"
          >
            <template slot-scope="scope">
              <div v-if="item.prop !== 'weekendArrangeFlag'">
                <div v-if="scope.row.isEdit">
                  <span v-if="item.prop === 'setMode'">
                    <el-select v-model="scope.row[item.prop]">
                      <el-option
                        v-for="(item, index) in settingList"
                        :key="'settingMode' + index"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </span>
                  <span v-else-if="item.prop === 'total'">
                    <el-input
                      v-model="scope.row[item.prop]"
                      maxlength="3"
                      :disabled="!scope.row['setMode'] || scope.row['setMode'] === '1'"
                      class="course-schedule-select"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      @blur="getSeries($event, item.prop, scope.$index)"
                    ></el-input>
                  </span>
                  <span v-else-if="item.prop.indexOf('Times') > 0">
                    <el-input
                      v-model="scope.row[item.prop]"
                      :disabled="!scope.row['setMode'] || scope.row['setMode'] === '2'"
                      maxlength="2"
                      class="course-schedule-select"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      @blur="getSeries($event, item.prop, scope.$index)"
                    ></el-input>
                  </span>
                  <span
                    v-else-if="item.prop === 'courseCode'"
                    :class="[
                      'course-schedule-course-link',
                      { 'course-schedule-course-link2': !scope.row['courseDays'] },
                    ]"
                    @click.stop="goCourse(scope.row)"
                  >
                    {{
                      scope.row[item.prop] +
                      "(" +
                      (scope.row["courseDays"] === null
                        ? $t("courseSchedule.noValid")
                        : (scope.row["courseStatus"] === $t("courseSchedule.downCourse")
                            ? $t("courseSchedule.downCourse") + "-"
                            : scope.row["courseStatus"] ===
                              $t("courseSchedule.noActivity")
                            ? $t("courseSchedule.noActivity") + "-"
                            : '') + scope.row["courseDays"]) +
                      ")"
                    }}</span
                  >
                  <span
                    v-else-if="item.prop === 'courseName'"
                    class="course-schedule-course-wrap"
                    >{{ scope.row[item.prop] + "-" + scope.row["courseTotal"] }}</span
                  >
                  <span
                    v-else-if="item.prop === 'siteName'"
                    class="course-schedule-course-wrap"
                    >{{ scope.row[item.prop] + "-" + scope.row["total"] }}</span
                  >
                  <span v-else-if="item.prop === 'district'">{{
                    scope.row[item.prop] + "-" + scope.row["districtTotal"]
                  }}</span>
                  <span class="course-add-table-cell" v-else>{{
                    scope.row[item.prop]
                  }}</span>
                </div>
                <div v-else>
                  <span
                    v-if="item.prop === 'courseCode'"
                    :class="[
                      'course-schedule-course-link',
                      { 'course-schedule-course-link2': !scope.row['courseDays'] },
                    ]"
                    @click.stop="goCourse(scope.row)"
                    >{{
                      scope.row[item.prop] +
                      "(" +
                      (scope.row["courseDays"] === null
                        ? $t("courseSchedule.noValid")
                        : (scope.row["courseStatus"] === $t("courseSchedule.downCourse")
                            ? $t("courseSchedule.downCourse") + "-"
                            : scope.row["courseStatus"] ===
                              $t("courseSchedule.noActivity")
                            ? $t("courseSchedule.noActivity") + "-"
                            : '') + scope.row["courseDays"]) +
                      ")"
                    }}</span
                  >
                  <span v-else-if="item.prop === 'setMode'">{{
                    filterSettingMode(scope.row[item.prop])
                  }}</span>
                  <span
                    v-else-if="item.prop === 'courseName'"
                    class="course-schedule-course-wrap"
                    >{{ scope.row[item.prop] + "-" + scope.row["courseTotal"] }}</span
                  >
                  <span
                    v-else-if="item.prop === 'siteName'"
                    class="course-schedule-course-wrap"
                    >{{ scope.row[item.prop] + "-" + scope.row["total"] }}</span
                  >
                  <span v-else-if="item.prop === 'district'">{{
                    scope.row[item.prop] + "-" + scope.row["districtTotal"]
                  }}</span>
                  <span v-else-if="item.prop.indexOf('Times') >= 0">{{
                    scope.row[item.prop] > 0 ? scope.row[item.prop] : null
                  }}</span>
                  <span v-else>{{ scope.row[item.prop] }}</span>
                </div>
              </div>
              <div v-if="item.prop === 'weekendArrangeFlag'">
                <span v-if="scope.row.isEdit || scope.row.weekEdit">
                  <el-select
                    v-model="scope.row[item.prop]"
                    class="course-schedule-select"
                  >
                    <el-option
                      v-for="(item, index) in weekClassList"
                      :key="'weekarrange' + index"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </span>
                <span class="course-add-table-cell" v-else>{{
                  filterWeek(scope.row[item.prop])
                }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column fixed="right" align="center" width="110" :label="$t('handle')">
          <template slot-scope="scope" v-if="checkPermission(scope.row)">
            <span
              class="schedule-manage-operate"
              v-if="!scope.row.isEdit"
              @click="edtiSchedule(scope.$index)"
              >{{ $t("course.edit") }}</span
            >
            <span
              class="schedule-manage-operate schedule-manage-operate2"
              v-if="!scope.row.isEdit"
              @click="deleteSchedule(scope.row)"
              >{{ $t("delete") }}</span
            >
            <span
              class="schedule-manage-operate"
              v-if="scope.row.isEdit"
              @click="saveSchedule(scope.row)"
              >{{ $t("save") }}</span
            >
            <span
              class="schedule-manage-operate schedule-manage-operate2"
              v-if="scope.row.isEdit"
              @click="closeSave(scope.$index)"
              >{{ $t("cancel") }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 场地选择弹框 -->
    <courseSiteChose
      :dialogShow="siteShow"
      @closeSiteChose="handleCloseSiteModal"
      v-if="siteShow"
      :courseId="courseId"
      :siteIds="siteIds"
      :courseType="siteCourseType"
      :searchFlag="searchFlag"
      :isCourse="isCourse"
      :searchParam="searchParam"
    ></courseSiteChose>
    <!-- 课程选择弹框 -->
    <courseChose
      :dialogShow="courseShow"
      @closeCourseChose="handleCloseCourseModal"
      v-if="courseShow"
    ></courseChose>
    <!-- 上传文件弹框 -->
    <scheduleUpload
      :dialogShow="uploadShow"
      @closeUploadChose="handleCloseUpload"
      v-if="uploadShow"
      :uploadParams="uploadParams"
    ></scheduleUpload>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import ClassTree from '@/components/rm/class-tree/index';
import courseSiteChose from './courseSiteModal.vue';
import courseChose from './courseModal.vue';
import scheduleUpload from './courseScheduleUploadModal.vue';

export default {
  components: {
    courseSiteChose,
    courseChose,
    scheduleUpload,
    'class-tree': ClassTree,
  },
  data() {
    return {
      searchData: {
        year: dayjs(new Date()).format('YYYY'),
        courseType: '',
        courseTypeKind: '',
        courseTypeKey: '',
        courseNameCode: '',
        siteNameCode: '',
        team: '',
        secondTeam: '',
        siteIdArr: [],
      },
      courseData: {
        courseCode: '',
        courseDays: null,
        courseScheduledDays: null,
        weekendArrangeFlag: '0',
        setMode: '2',
        total: 0,
        siteId: [],
      },
      teamList: [],
      teamListTwo: [],
      teamPerms: 'TRAINERTEAM',
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      queryTreeUrl: '/learning/coursecatalog/list',
      defaultPropsz: {
        children: 'children',
        label: 'catalogNameCn',
        id: 'catalogId',
      },
      cityDefaultProps: {
        children: 'childrenRegionList',
        label: 'cityName',
      },
      areaList: [],
      cityList: [],
      cityListName: '',
      allTeamCatalog: [],
      showVehicleClassList: [],
      showValue: '',
      siteShow: false,
      courseShow: false,
      addContainShow: false,
      calWidth: 300,
      weekClassList: this.enums['weekArrangeFlag'],
      settingList: this.enums['yearTargetSetMode'],
      yearList: [],
      isNew: false,
      weekShow: false,
      courseId: '',
      scheduleTargetId: '',
      isCourse: false,
      scheduleLoading: false,
      courseType: '',
      courseTypeKey: '',
      scheduleData: [],
      columnList: [
        {
          label: this.$t('courseSchedule.courseGroup'),
          prop: 'courseTeamCatalogNames',
          width: 120,
        },
        { label: this.$t('courseSchedule.courseType'), prop: 'courseKindName' },
        { label: this.$t('courseSchedule.courseIndex'), prop: 'courseCode', width: 130 },
        {
          label: this.$t('courseSchedule.courseCalculate'),
          prop: 'courseName',
          width: 140,
        },
        {
          label: this.$t('courseSchedule.weekendClass'),
          prop: 'weekendArrangeFlag',
          width: 105,
        },
        { label: this.$t('courseSchedule.areaCalculate'), prop: 'district' },
        { label: this.$t('courseSchedule.siteCalculate'), prop: 'siteName', width: 210 },
        { label: this.$t('courseSchedule.settingMode'), prop: 'setMode', width: 140 },
        { label: this.$t('courseSchedule.targetNum'), prop: 'total' },
        { label: '1' + this.$t('courseSchedule.month'), prop: 'janTimes' },
        { label: '2' + this.$t('courseSchedule.month'), prop: 'febTimes' },
        { label: '3' + this.$t('courseSchedule.month'), prop: 'marTimes' },
        { label: '4' + this.$t('courseSchedule.month'), prop: 'aprTimes' },
        { label: '5' + this.$t('courseSchedule.month'), prop: 'mayTimes' },
        { label: '6' + this.$t('courseSchedule.month'), prop: 'junTimes' },
        { label: '7' + this.$t('courseSchedule.month'), prop: 'julTimes' },
        { label: '8' + this.$t('courseSchedule.month'), prop: 'augTimes' },
        { label: '9' + this.$t('courseSchedule.month'), prop: 'sepTimes' },
        { label: '10' + this.$t('courseSchedule.month'), prop: 'octTimes' },
        { label: '11' + this.$t('courseSchedule.month'), prop: 'novTimes' },
        { label: '12' + this.$t('courseSchedule.month'), prop: 'decTimes' },
      ],
      spanArr1: [],
      spanArr2: [],
      spanArr3: [],
      spanArr4: [],
      spanArr5: [],
      uploadShow: false,
      editOne: false,
      siteCourseType: '',
      downloadingData: false,
      siteIds: [],
      saveLoading: true,
      delLoading: true,
      calHeight: 400,
      searchFlag: 1,
      searchParam: dayjs(new Date()).format('YYYY')
    };
  },
  computed: {
    courseTypeList() {
      const arr1 = this.enums['courseGroupType'].map((item) => {
        return { ...item, code: 'courseGroupType' + item.code };
      });
      const arr2 = this.enums['courseKind'].map((item) => {
        return { ...item, code: 'courseKind' + item.code };
      });
      return arr1.concat(arr2);
    },
  },
  methods: {
    renderHeader (h, {column}) {
      return h('div', [
        h('span', column.label),
          h(
            'el-tooltip',
            {
                props: {
                  effect: 'light',
                  content: this.$t('courseTask.settingModeInfo'),
                  placement: 'top',
                },
            },
            [
              h('i', {
                  class: 'el-icon-question',
                  style: 'color:#409eff;margin-left:5px;',
              }),
            ],
          ),
      ]);
    },
    renderHeader2 (h, {column}) {
      return h('div', [
        h('span', column.label)
      ]);
    },
    checkPermission(row) {
      const dic = 'SC_TARGET_EDIT:' + row.courseTeamCatalogSecond;
      if (JSON.parse(sessionStorage.getItem('v1user_data')).userCode === 'admin') {
        return true;
      }
      return this.$hasPermission(dic);
    },
    // 勾选分类树 树时调用
    handleCheckChange() {
      const checkedValTem = this.$refs.cityClassTree
        .getCheckedNodes(true, false)
        .map((item) => {
          return item;
        });
      this.cityListName = checkedValTem.map((item) => item.cityName).toString();
      this.cityList = checkedValTem;
    },
    resetChecked() {
      this.cityListName = '';
      this.cityList = [];
      this.$refs.cityClassTree.setCheckedKeys([]);
    },
    getTypeKey(val) {
      if (!val) {
        this.searchData.courseTypeKey = '';
        this.searchData.courseType = '';
      }
      if (val.indexOf('courseKind') >= 0) {
        this.searchData.courseTypeKey = val.substr(10);
        this.searchData.courseType = 'courseKind';
      }
      if (val.indexOf('courseGroupType') >= 0) {
        this.searchData.courseTypeKey = val.substr(15);
        this.searchData.courseType = 'courseGroupType';
      }
    },
    getGroupListOne() {
      // 课程团队分类二级
      this.allTeamCatalog = this.teamcatalogSecond;
      const arr = new Set();
      const data = [];
      const obj = {};
      const codes = this.teamcatalogOne.map((item) => item.code);
      this.teamcatalogOne.forEach((item) => {
        obj[item.code] = item;
      });
      // 课程团队分类一级
      this.allTeamCatalog.forEach((item) => {
        const code = item.code.slice(0, 2);
        if (!arr.has(code) && codes.includes(code)) {
          arr.add(code);
          data.push(obj[code]);
        }
      });
      this.teamList = [...arr].length === 0 ? this.teamcatalogOne : data;
    },
    getYearList() {
      this.$request.post('/classschedule/scheduleTarget/initParams').then((res) => {
        if (res) {
          this.yearList = res.yearList;
          const data = res.cityList || {};
          const cityList = [];
          Object.keys(data).forEach((item) => {
            cityList.push({
              cityName: item,
              childrenRegionList: data[item],
              cityId: item,
            });
          });
          this.areaList = cityList;
        }
      });
    },
    getTeamTwo(e) {
      this.searchData.secondTeam = '';
      this.teamListTwo = this.allTeamCatalog.filter((item) => {
        return e === item.code.slice(0, 2);
      });
    },
    filterSettingMode(val) {
      for (let i of this.settingList) {
        if (val * 1 === i.code * 1) {
          return i.name;
        }
      }
    },
    filterWeek(val) {
      for (let i of this.weekClassList) {
        if (val === i.code) {
          return i.name;
        }
      }
    },
    edtiSchedule(index) {
      if (this.scheduleData.filter((item) => item.isEdit).length === 0) {
        this.$set(this.scheduleData[index], 'isEdit', true);
        const {
          courseTeamCatalogNames,
          courseKindName,
          courseCode,
          courseName,
        } = this.scheduleData[index];
        for (let [k, i] of this.scheduleData.entries()) {
          if (k !== index) {
            if (
              i.courseTeamCatalogNames === courseTeamCatalogNames &&
              i.courseKindName === courseKindName &&
              i.courseCode === courseCode &&
              i.courseName === courseName
            ) {
              this.$set(this.scheduleData[k], 'weekEdit', true);
            }
          }
        }
      } else {
        this.$message({
          message: this.$t('courseSchedule.editOneInfo'),
          type: 'warning',
        });
      }
    },
    closeSave(index) {
      this.searchList(
        true,
        this.$el.querySelectorAll('.el-table__row')[index].offsetTop - 10
      );
    },
    changeMonthData(val) {
      const arr = [
        'janTimes',
        'febTimes',
        'marTimes',
        'aprTimes',
        'mayTimes',
        'junTimes',
        'julTimes',
        'augTimes',
        'sepTimes',
        'octTimes',
        'novTimes',
        'decTimes',
      ];
      const data = [];
      Object.keys(val).forEach((item) => {
        if (item.indexOf('Times') >= 0) {
          data.push({ month: arr.indexOf(item) + 1, times: val[item] * 1 || 0 });
        }
      });
      return data;
    },
    // 编辑保存单条
    saveSchedule(val) {
      if (this.saveLoading) {
        this.saveLoading = false;
        if (!val.setMode) {
          this.$message({
            message: this.$t('courseSchedule.setModeInfo'),
            type: 'warning',
          });
          this.saveLoading = true;
          return false;
        }
        if (val.setMode === '2' && !val.total) {
          this.$message({
            message: this.$t('courseSchedule.setModeInfo2'),
            type: 'warning',
          });
          this.saveLoading = true;
          return false;
        }
        const timesList = this.changeMonthData(val);
        if (val.setMode === '1' && timesList.length === 0) {
          this.$message({
            message: this.$t('courseSchedule.setModeInfo3'),
            type: 'warning',
          });
          this.saveLoading = true;
          return false;
        }
        const sum = timesList.reduce((pre, now) => {
          return pre + now.times * 1;
        }, 0);
        if (val.setMode === '1' && sum === 0) {
          this.$message({
            message: this.$t('courseSchedule.setModeInfo3'),
            type: 'warning',
          });
          this.saveLoading = true;
          return false;
        }
        const params = {
          scheduleTargetId: val.scheduleTargetId,
          scheduleTargetDetailId: val.scheduleTargetDetailsId,
          weekendArrangeFlag: val.weekendArrangeFlag * 1,
          setMode: val.setMode * 1,
          total: val.setMode === '1' ? sum : val.total * 1,
          timesList: val.setMode === '1' ? timesList : [],
        };
        this.$request
          .post('/classschedule/scheduleTarget/edit', params)
          .then((_res, _total, _code, data) => {
            if (data.msg === 'success') {
              this.$message({
                message: this.$t('courseSchedule.editSuccess'),
                type: 'success',
              });
              this.saveLoading = true;
              this.searchList(false, 0, val.scheduleTargetDetailsId, '');
            }
          })
          .catch(() => {
            this.saveLoading = true;
          });
      }
    },
    // 删除数据
    deleteSchedule(val) {
      this.$confirm(this.$t('courseSchedule.delTargetInfo'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(() => {
        if (this.delLoading) {
          this.delLoading = false;
          this.$request
            .post('/classschedule/scheduleTarget/delete', {
              scheduleTargetDetailId: val.scheduleTargetDetailsId,
              scheduleTargetId: val.scheduleTargetId,
            })
            .then((res) => {
              if (res) {
                this.$message({
                  message: this.$t('courseSchedule.delSuccess'),
                  type: 'success',
                });
                this.delLoading = true;
                this.searchList(true, 0, '', val.scheduleTargetId);
              }
            })
            .catch(() => {
              this.delLoading = true;
            });
        }
      });
    },
    showSite() {
      this.siteShow = true;
      this.isNew = false;
      this.isCourse = false;
      this.searchParam = this.searchData.year;
    },
    showSite2() {
      if (!this.courseId) {
        this.$message({
          message: this.$t('courseSchedule.courseChoseFrist'),
          type: 'warning',
        });
        return false;
      }
      this.siteShow = true;
      this.isNew = true;
      this.isCourse = true;
      this.searchParam = this.searchData.year;
    },
    showCourse() {
      this.courseShow = true;
    },
    showAddCourse() {
      this.addContainShow = true;
      this.courseData = {
        courseData: '',
        weekendArrangeFlag: '0',
        setMode: '',
        courseDays: null,
        courseScheduledDays: null,
      };
      this.courseId = '';
      this.courseType = '';
      this.courseTypeKey = '';
      this.siteCourseType = '';
      this.scheduleTargetId = '';
    },
    resetAndClose(type, height, courseCode) {
      this.courseData = {
        courseData: '',
        weekendArrangeFlag: '0',
        setMode: '',
        courseDays: null,
        courseScheduledDays: null,
      };
      this.courseId = '';
      this.courseType = '';
      this.courseTypeKey = '';
      this.isNew = false;
      this.addContainShow = false;
      this.weekShow = false;
      this.siteCourseType = '';
      this.scheduleTargetId = '';
      this.siteIds = [];
      if (type) {
        this.searchList(type, height, '', '', courseCode);
      }
    },
    resetArraySpan() {
      this.spanArr1 = [];
      this.spanArr2 = [];
      this.spanArr3 = [];
      this.spanArr4 = [];
      this.spanArr5 = [];
    },
    // 新建目标
    saveNewTarget() {
      const params = {
        year: this.searchData.year * 1,
        weekendArrangeFlag: this.weekShow ? this.courseData.weekendArrangeFlag * 1 : null,
        siteIds: this.courseData.siteId,
        courseId: this.courseId,
        courseType: this.courseType,
        courseTypeKey: this.courseTypeKey,
        setMode: this.courseData.setMode,
      };
      if (this.scheduleTargetId) {
        params.scheduleTargetId = this.scheduleTargetId;
      }
      if (!this.courseData.courseCode) {
        this.$message({
          message: this.$t('courseSchedule.courseChoseFrist'),
          type: 'warning',
        });
        return false;
      }
      if (!this.courseData.siteId) {
        this.$message({
          message: this.$t('courseSchedule.addScheduleInfo1'),
          type: 'warning',
        });
        return false;
      }
      this.$request
        .post('/classschedule/scheduleTarget/save', params)
        .then((_res, _total, _code, data) => {
          if (data.msg === 'success') {
            this.$message({
              message: this.$t('courseSchedule.addSuccess'),
              type: 'success',
            });
            this.resetAndClose(true, 0, this.courseData.courseCode, '');
          }
        })
        .catch(() => {
          this.resetAndClose(true, 0, this.courseData.courseCode, '');
        });
    },
    handleCloseSiteModal(val) {
      this.siteShow = false;
      this.siteIds = [];
      if (val && val.siteInfo.length > 0) {
        if (this.isNew) {
          this.courseData.siteNameCode = val.siteInfo
            .map((item) => item.siteCnName)
            .join('/');
          this.courseData.siteId = val.siteInfo.map((item) => item.siteId);
        } else {
          this.searchData.siteNameCode = val.siteInfo
            .map((item) => item.siteCnName)
            .join('/');
          this.searchData.siteIdArr = val.siteInfo.map((item) => item.siteId);
          this.weekShow = false;
        }
        this.siteIds = val.siteInfo.map((item) => item.siteId);
      }
    },
    handleCloseCourseModal(val) {
      this.courseShow = false;
      this.courseData = {
        courseData: '',
        weekendArrangeFlag: '0',
        setMode: '2',
        courseDays: null,
        courseScheduledDays: null,
      };
      this.siteIds = [];
      this.scheduleTargetId = '';
      if (val && val.courseInfo && val.courseInfo.courseKind) {
        this.courseData.courseCode = val.courseInfo.courseCode;
        this.courseData.courseDays = val.courseInfo.courseDays || val.courseScheduledDays;
        this.courseData.courseScheduledDays = val.courseInfo.courseScheduledDays || null;
        if (val.courseInfo.courseKind.indexOf('courseKind') >= 0) {
          this.courseTypeKey = val.courseInfo.courseKind.substr(10);
          this.courseType = 'courseKind';
          this.siteCourseType = '';
        }
        if (val.courseInfo.courseKind.indexOf('courseGroupType') >= 0) {
          this.courseTypeKey = val.courseInfo.courseKind.substr(15);
          this.courseType = 'courseGroupType';
          this.siteCourseType = this.courseTypeKey === '1' ? '2' : '3';
        }
        this.courseId = val.courseInfo.courseId;
        this.$request
          .get(
            `/classschedule/scheduleTarget/queryScheduleTargetByCourseId?courseId=
            ${val.courseInfo.courseId}&year=${this.searchData.year}`
          )
          .then((res) => {
            if (res === null) {
              this.weekShow = true;
            } else {
              this.scheduleTargetId = res.id;
            }
          });
      } else {
        this.courseId = '';
      }
    },
    getSeries(e, keyName, bindex) {
      this.$set(this.scheduleData[bindex], keyName, e.target.value);
    },
    searchList(type, height, scheduleTargetDetailsId, scheduleTargetId, courseCode) {
      const params = {
        year: this.searchData.year,
        courseType: this.searchData.courseType,
        courseTypeKey: this.searchData.courseTypeKey,
        siteIds:
          this.searchData.siteIdArr.length > 0
            ? this.searchData.siteIdArr.toString()
            : '',
        courseNameOrCode: this.searchData.courseNameCode,
        cityIds:
          this.cityList.length > 0
            ? this.cityList.map((item) => item.cityId).toString()
            : '',
        courseTeamCatalogFirst: this.searchData.team,
        courseTeamCatalogSecond: this.searchData.secondTeam,
      };
      this.scheduleLoading = true;
      this.scheduleData = [];
      this.$request
        .post('/classschedule/scheduleTarget/queryScheduleTarget', params)
        .then((res) => {
          if (res) {
            let findex = 0;
            this.scheduleData = res.map((item, index) => {
              if (
                scheduleTargetDetailsId &&
                item.scheduleTargetDetailsId === scheduleTargetDetailsId
              ) {
                findex = index;
              }
              Object.keys(item).forEach((k) => {
                if (k.indexOf("Times") >= 0) {
                  item[k] = item[k] > 0 ? item[k] : null;
                }
              });
              return {
                ...item,
                setMode: item.setMode ? item.setMode.toString() : null,
                weekendArrangeFlag: item.weekendArrangeFlag.toString(),
                isEdit: false,
                weekEdit: false,
              };
            });
            let scheduleTargetIdIndex = 0;
            if (scheduleTargetId) {
              for (let [k, i] of this.scheduleData.entries()) {
                if (i.scheduleTargetId === scheduleTargetId) {
                  scheduleTargetIdIndex = k;
                  break;
                }
              }
            }
            let codeIndex = 0;
            if (courseCode) {
              for (let [k, i] of this.scheduleData.entries()) {
                if (i.courseCode === courseCode) {
                  codeIndex = k;
                  break;
                }
              }
            }
            this.resetArraySpan();
            this.mergeData();
            this.scheduleLoading = false;
            if (type) {
              if (scheduleTargetId) {
                setTimeout(() => {
                  this.$el.querySelector('.el-table__body-wrapper').scrollTop =
                    this.$el.querySelectorAll('.el-table__row')[scheduleTargetIdIndex]
                      .offsetTop - 10;
                });
              } else if (courseCode) {
                setTimeout(() => {
                  this.$el.querySelector('.el-table__body-wrapper').scrollTop =
                    this.$el.querySelectorAll('.el-table__row')[codeIndex].offsetTop - 10;
                });
              } else {
                setTimeout(() => {
                  this.$el.querySelector('.el-table__body-wrapper').scrollTop = height;
                });
              }
            } else {
              setTimeout(() => {
                this.$el.querySelector('.el-table__body-wrapper').scrollTop =
                  this.$el.querySelectorAll('.el-table__row')[findex].offsetTop - 10;
              });
            }
          }
        })
        .catch(() => {
          this.scheduleLoading = false;
        });
    },
    resetList() {
      Object.keys(this.searchData).forEach((item) => {
        if (item === 'siteIdArr') {
          this.searchData[item] = [];
        } else {
          this.searchData[item] = '';
        }
      });
      this.searchData.year = dayjs(new Date()).format('YYYY');
      this.cityList = [];
      this.courseType = '';
      this.courseTypeKey = '';
      this.siteCourseType = '';
      this.siteIds = [];
      this.resetChecked();
      this.searchList(true, 0);
    },
    // 合并单元格
    arraySpanMethod({ _row, _column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return {
          rowspan: this.spanArr1[rowIndex],
          colspan: this.spanArr1[rowIndex] > 0 ? 1 : 0,
        };
      } else if (columnIndex === 2) {
        return {
          rowspan: this.spanArr2[rowIndex],
          colspan: this.spanArr2[rowIndex] > 0 ? 1 : 0,
        };
      } else if (columnIndex === 3) {
        return {
          rowspan: this.spanArr3[rowIndex],
          colspan: this.spanArr3[rowIndex] > 0 ? 1 : 0,
        };
      } else if (columnIndex === 4 || columnIndex === 5) {
        return {
          rowspan: this.spanArr4[rowIndex],
          colspan: this.spanArr4[rowIndex] > 0 ? 1 : 0,
        };
      } else if (columnIndex === 6) {
        return {
          rowspan: this.spanArr5[rowIndex],
          colspan: this.spanArr5[rowIndex] > 0 ? 1 : 0,
        };
      }
    },
    mergeData() {
      let index1 = 0;
      let index2 = 0;
      let index3 = 0;
      let index4 = 0;
      let index5 = 0;
      const data = this.scheduleData;
      for (let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
          this.spanArr2.push(1);
          this.spanArr3.push(1);
          this.spanArr4.push(1);
          this.spanArr5.push(1);
        } else {
          if (
            i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames &&
            i.courseCode === data[k - 1].courseCode
          ) {
            this.spanArr1[index1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            index1 = k;
          }
          if (
            i.courseKindName === data[k - 1].courseKindName &&
            i.courseCode === data[k - 1].courseCode
          ) {
            this.spanArr2[index2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            index2 = k;
          }
          if (i.courseCode === data[k - 1].courseCode) {
            this.spanArr3[index3] += 1;
            this.spanArr3.push(0);
          } else {
            this.spanArr3.push(1);
            index3 = k;
          }
          if (
            i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames &&
            i.courseKindName === data[k - 1].courseKindName &&
            i.courseCode === data[k - 1].courseCode &&
            i.courseName === data[k - 1].courseName
          ) {
            this.spanArr4[index4] += 1;
            this.spanArr4.push(0);
          } else {
            this.spanArr4.push(1);
            index4 = k;
          }
          if (
            i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames &&
            i.courseKindName === data[k - 1].courseKindName &&
            i.courseCode === data[k - 1].courseCode &&
            i.courseName === data[k - 1].courseName &&
            i.district === data[k - 1].district
          ) {
            this.spanArr5[index5] += 1;
            this.spanArr5.push(0);
          } else {
            this.spanArr5.push(1);
            index5 = k;
          }
        }
      }
    },
    // 根据课程类型进行跳转
    goCourse(val) {
      if (!val.courseDays) {
        return false;
      }
      if (val.courseType === 'courseKind') {
        this.$router.push({
          name: 'learning-course-courseShow',
          query: {
            courseId: val.courseId,
          },
        });
        this.$eventHub.$emit('showViewCourse', '');
      } else {
        this.$router.push({
          name: 'rm-courseGroup-courseGroupDetail',
          query: {
            id: val.courseId,
          },
        });
        this.$eventHub.$emit('courseGroupDetail', '');
      }
    },
    uploadFileShow() {
      this.uploadShow = true;
      this.uploadParams = {
        year: this.searchData.year,
        courseType: this.courseType,
        courseTypeKey: this.courseTypeKey,
        siteIds:
          this.searchData.siteIdArr.length > 0
            ? this.searchData.siteIdArr.toString()
            : '',
        courseNameOrCode: this.searchData.courseNameCode,
        cityIds:
          this.cityList.length > 0
            ? this.cityList.map((item) => item.cityId).toString()
            : '',
        courseTeamCatalogFirst: this.searchData.team,
        courseTeamCatalogSecond: this.searchData.secondTeam,
      };
    },
    handleCloseUpload(val) {
      this.uploadShow = false;
      if (val.isFresh) {
        this.searchList(true, 0);
      }
    },
    changeYear() {
      this.addContainShow = false;
      this.searchList(true, 0);
    },
    downLoadTarget() {
      clearTimeout(this.timeout);
      const params = {
        year: this.searchData.year,
        courseType: this.searchData.courseType,
        courseTypeKey: this.searchData.courseTypeKey,
        siteIds:
          this.searchData.siteIdArr.length > 0
            ? this.searchData.siteIdArr.toString()
            : '',
        courseNameOrCode: this.searchData.courseNameCode,
        cityIds:
          this.cityList.length > 0
            ? this.cityList.map((item) => item.cityId).toString()
            : '',
        courseTeamCatalogFirst: this.searchData.team,
        courseTeamCatalogSecond: this.searchData.secondTeam,
      };
      this.downloadingData = true;
      this.$request.downloadByPost7(
        '/classschedule/scheduleTarget/export',
        `${this.searchData.year + 
        this.$t('courseSchedule.yearTemplateDownload')  }.xls`,
        params,
        null,
        'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downloadingData = false;
      }, 2000);
    },
  },
  mounted() {
    this.getGroupListOne();
    this.getYearList();
    this.calWidth = this.$refs.courseModuleWidth.offsetWidth;
    setTimeout(() => {
      this.calHeight = window.innerHeight - 100;
    });
    window.onresize = () => {
      setTimeout(() => {
        this.calHeight = window.innerHeight - 100;
      });
      this.calWidth = this.$refs.courseModuleWidth.offsetWidth;
    };
    this.searchList(true, 0);
  },
  destroyed() {
    clearTimeout(this.timeout);
    this.timeout = null;
  },
};
</script>
<style lang="scss" scoped>
.course-schedule-manage-contain {
  min-height: calc(100% - 120px);
  .course-schedule-search {
    height: 100%;
    width: 100%;
    display: flex;
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 12px;
    .search-lf {
      flex: 8;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .search-module {
        flex: 0 0 32%;
        padding-right: 5%;
        margin-bottom: 12px;
        .search-module-name {
          padding: 0;
          margin: 0;
          line-height: 26px;
          &.search-module-name2 {
            color: #409eff;
            cursor: pointer;
          }
        }
        .search-module-value {
          height: 34px;
          .search-value-select {
            width: 60%;
            float: left;
            &.select-secondteam {
              width: 40%;
            }
          }
        }
        .el-date-editor {
          width: 100% !important;
        }
      }
    }
    .search-lr {
      flex: 1;
      vertical-align: middle;
      padding-top: 10px;
      .button-margin-b {
        margin-bottom: 7px;
      }
    }
  }
  .course-schedule-add-buttons,
  .course-schedule-add-content {
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 12px;
  }
  .course-schedule-add-content {
    .course-schedule-add-info {
      display: flex;
      flex-wrap: nowrap;
    }
    .add-table-contain {
      overflow: hidden;
    }
    .add-infos {
      display: flex;
      flex: 1;
      align-items: center;
      margin-bottom: 20px;
      position: relative;
    }
    .add-infos2 {
      width: 152px;
      padding-top: 23px;
      overflow: hidden;
      .add-infos-module {
        margin: 0 !important;
      }
    }
    .add-infos-table {
      width: 100%;
    }
    .add-infos-module {
      margin-right: 20px;
      &.add-infos-module2 {
        padding-top: 24px;
        margin-right: 30px;
      }
      &.add-infos-module4 {
        width: 140px;
      }
      &.add-infos-module5 {
        width: 120px;
      }
      &.add-infos-module6 {
        width: 100px;
      }
      .add-infos-module-name {
        line-height: 26px;
        margin: 0;
        padding: 0;
        .icon-question {
          color:#409eff;
        }
        &.add-infos-module-name2 {
          color: #409eff;
          cursor: pointer;
        }
      }
    }
  }
  .course-schedule-content {
    background-color: #ffffff;
    padding: 15px;
    margin-bottom: 12px;
    .course-schedule-table {
      width: 100%;
      .schedule-manage-operate {
        cursor: pointer;
        color: #409eff;
        &.schedule-manage-operate2 {
          margin-left: 10px;
        }
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .course-schedule-course-link {
      color: #409eff;
      cursor: pointer;
      text-decoration: underline;
      word-break: break-all;
      white-space: pre-line;
      &.course-schedule-course-link2 {
        cursor: default;
        color: #606266;
      }
    }
    .course-schedule-course-wrap {
      word-break: break-word;
      white-space: pre-wrap;
    }
  }
}
</style>
<style lang="scss">
.course-schedule-manage-contain {
  .select-secondteam {
    .el-input__inner {
      border-left: none !important;
    }
  }
  .search-module-value2 {
    .el-input__inner {
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
    }
  }
  .course-schedule-select {
    .el-input__inner {
      text-align: center !important;
    }
  }
}
</style>
